export default __webpack_public_path__ + "static/media/aviabue-dt.5470b825.png";